import axios from "axios";
import VPagination from "@hennge/vue3-pagination";
import store from "@/store";

export default {
  name: "ArmManagement",
  components: {
    VPagination,
  },
  data() {
    return {
      arms: [],
      editIndex: null,
      editableRow: null,
      protocolId: "",
      idToken: "",
      pageindex: 1,
      pageSize: 10,
      SortProperty: "armCode",
      sortorder: 0,
      totalPages: 1,
      totalCount: 0,
       SortOrderInt: 0,
    isAscending: true,
      currentPage: 1,
      loadNextPage: false,
      baseurl: process.env.VUE_APP_Service_URL,
      validationErrors: {},
      armTypeList: [],
      protocol: {},
      isAddingNew: false,
      newRow: {
        armCode: "",
        armName: "",
        armType: "",
        description: "",
        soaId: "",
      },
      newRowErrors: {},
    };
  },
  async mounted() {
    this.idToken = store.getters.getIdToken;
    this.protocolId = this.$route.query.id;
    await this.getProtocolbyId();
    if (this.protocolId) {
      await this.listArms(this.protocolId);
    }
  },
  methods: {
    SortSelected(sortProp) {
      if (this.SortProperty === sortProp) {
        this.isAscending = !this.isAscending;
      } else {
        this.SortProperty = sortProp;
        this.isAscending = true;
      }

      this.sortorder = this.isAscending ? 0 : 1;
      this.SortOrderInt = this.sortorder;

      this.pageindex = 1;
      this.currentPage = 1;

      this.listArms(this.protocolId);
    },
    async listArms(protocolId) {
      await axios
        .get(
          `${this.baseurl}/management/studyprotocol/listdastudyarms?protocolId=${this.protocolId}&pageindex=${this.pageindex}&pagesize=${this.pageSize}&SortProperty=${this.SortProperty}&SortOrder=${this.sortorder}`,
          {
            headers: {
              Authorization: "Bearer " + this.idToken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.arms = res.data.results;
          this.totalCount = res.data.totalCount;
          this.totalPages = Math.ceil(res.data.totalCount / this.pageSize);
        })
        .catch((err) => console.log("Error in fetching arms:", err));
    },
    editRow(index, arm) {
      this.editIndex = index;
      this.editableRow = { ...arm };
      this.validationErrors = {};
    },
    validateRow() {
      this.validationErrors = {};
      if (!this.editableRow.armCode) {
        this.validationErrors.armCode = "ARM Code is required.";
      }
      if (!this.editableRow.armName) {
        this.validationErrors.armName = "Arm Name is required.";
      }
  
      return Object.keys(this.validationErrors).length === 0;
    },
    async updateRow(daArmId) {
      try {
        if (!this.editableRow) {
          console.error("No editable row found.");
          return;
        }

        if (!this.validateRow()) {
          return;
        }

        const updateData = {
          daArmId: daArmId,
          protocolRefId: this.protocolId, 
          studyId: this.editableRow.studyId, 
          armCode: this.editableRow.armCode,
          armName: this.editableRow.armName,
          armType: this.editableRow.armType,
          description: this.editableRow.description,
          soaId: this.editableRow.soaId || "",
        };

        const response = await axios.put(
          `${this.baseurl}/management/studyprotocol/updatedaarm`,
          updateData,
          {
            headers: {
              Authorization: `Bearer ${this.idToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        console.log("Update response:", response.data);

        await this.getProtocolbyId();
        this.cancelEdit();
        await this.listArms(this.protocolId);

        alert("Arm details updated successfully.");
      } catch (err) {
        console.error("Error during updateRow API call:", err);
        alert("Failed to update arm. Please try again.");
      }
    },
    cancelEdit() {
      this.editIndex = null;
      this.editableRow = null;
    },
    clearFieldError(fieldName) {
      if (this.validationErrors[fieldName]) {
        delete this.validationErrors[fieldName];
      }
    },
    async loadPage(page) {
      this.currentPage = page;
      this.pageindex = page;
      this.loadNextPage = true;
      await this.listArms(this.protocolId);
    },
    async deleteRow(armId) {
      try {
        const confirmation = confirm("Are you sure you want to delete this arm?");
        if (!confirmation) return;

        const response = await axios.delete(
          `${this.baseurl}/management/studyprotocol/deletebyid?collectionName=DaScrape_Arm&id=${armId}`,
          {
            headers: {
              Authorization: `Bearer ${this.idToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        console.log("Delete response:", response.data);
        await this.listArms(this.protocolId);
        if (this.arms.length === 0 && this.currentPage > 1) {
          this.currentPage--;
          this.pageindex = this.currentPage;
          await this.listArms(this.protocolId);
        }
        alert("Arm deleted successfully.");
      } catch (error) {
        console.error("Error during arm delete API call:", error);
        alert("Failed to delete the arm. Please try again.");
      }
    },
    async getProtocolbyId() {
      const token = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/management/document/getprotocolbyid?protocolId=${this.protocolId}`,
          {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.protocol = res.data;
        })
        .catch((err) => console.log("error in get protocol by id", err));
    },
    addNewRow() {
      this.isAddingNew = true;
      this.newRow = { armCode: "", armName: "", armType: "", description: "", soaId: "" };
      this.newRowErrors = {};
      // Cancel any active edit
      this.editIndex = null;
      this.editableRow = null;
    },

    cancelNewRow() {
      this.isAddingNew = false;
      this.newRowErrors = {};
    },

    clearNewFieldError(fieldName) {
      if (this.newRowErrors[fieldName]) {
        delete this.newRowErrors[fieldName];
      }
    },

    validateNewRow() {
      this.newRowErrors = {};
      if (!this.newRow.armCode) {
        this.newRowErrors.armCode = "Arm Code is required.";
      }
      if (!this.newRow.armName) {
        this.newRowErrors.armName = "Arm Name is required.";
      }
      return Object.keys(this.newRowErrors).length === 0;
    },

    async saveNewRow() {
      if (!this.validateNewRow()) return;

      try {
        const payload = {
          collectionName: "DaScrape_Arm",
          data: {
            protocolRefId: this.protocolId,
            armCode: this.newRow.armCode,
            armName: this.newRow.armName,
            armType: this.newRow.armType,
            description: this.newRow.description,
            soaId: this.newRow.soaId,
            studyId: this.protocol.studyId,
          },
        };

        await axios.post(
          `${this.baseurl}/management/studyprotocol/genericinsert`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${this.idToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        this.isAddingNew = false;
        this.newRowErrors = {};

        await this.listArms(this.protocolId);

        alert("Arm created successfully.");
      } catch (err) {
        console.error("Error creating arm:", err);
        alert("Failed to create arm. Please try again.");
      }
    }
  },
};